export interface IApplicationUser {
  UserGuid: any;
  Status: any;
  Applications: any;
  ApplicationsGuids: any[];
}

export interface IMenuByUserResponse {
  applicationMenus: ApplicationMenu[];
  Errors: string[];
}

export interface ApplicationMenu {
  modules: ModuleMenu[];
  applicationGuid: string;
  name: string;
  description: string;
  logo: string | null;
  logoDark: string | null;
  icon: string | null;
  iconDark: string | null;
  target: string;
  url: string | null;
  active: boolean;
  isShare: boolean;
  products: any;
  productsGuid: any;
}

export interface ModuleMenu {
  applicationGuid: string;
  moduleGuid: string;
  name: string;
  description: string;
  icon: string | null;
  iconDark: string | null;
  logo: string | null;
  logoDark: string | null;
  order: number;
  url: string;
  externalUrl: string | null;
  isQuickLink: boolean;
  active: boolean;
  moduleId: number;
  type: number;
  level: number;
  parentId: number;
  showChildrenSideMenu: boolean;
  isReportHub: boolean;
  children: ModuleMenu[];
  translates: LanguageTranslate[];
  isParent: boolean;
  isForEdge: boolean;
  translation?: string;
}

export interface LanguageTranslate {
  languageCode: 'EN' | 'ES';
  key: string;
  value: string;
}

// Estado para el store
export interface MenuByUserState {
  data: IMenuByUserResponse | null;
  loading: boolean;
  error: string | null;
}

export const initialMenuByUserState: MenuByUserState = {
  data: null,
  loading: undefined,
  error: null,
};
